<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<button mat-raised-button class="fileroom-button fileroom-upload-button" (click)="openUploadDialog()" style="padding-bottom: 8px;border-radius: 10px;text-align: center;vertical-align: text-top;color: #FFF !important;position: relative;border: none;">
  Upload New <mat-icon class="fileroom-upload-button-add-align" style="position: relative; top: 7px;">add</mat-icon>
</button>
